<template>
  <swiper
    ref="mySwiper"
    :modules="modules"
    :effect="'fade'"
    :loop="true"
    :navigation="{
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }"
    :autoplay="{ delay: 5000 }"
  >
    <swiper-slide v-for="item in sliderData" :key="item.id">
      <div class="news-list swiper-slide d-flex align-items-center ">
        <b-container>
          <b-row>
            <b-col md="4" cols="12">
              <div class="d-flex align-items-center justify-content-center">
                <img
                :src="require('@/assets/img/news/' + item.img)"
                alt="news"
                width="200"
              />
              </div>

            </b-col>
            <b-col md="8" cols="12">
              <h1 class="mb-4">{{ item.title }}</h1>
              <p class="news-des">
                {{ item.description }}
              </p>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </swiper-slide>
  </swiper>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, EffectFade, Autoplay } from "swiper";
export default {
  name: "HomeSlider",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      sliderData: [
        {
          id: "1",
          img: "news.jpeg",
          title: " رؤيتنا ",
          description: ` تحقيقا لرؤية المملكة 2030 بأن تكون المملكة في مصاف الدول العشر الأكثر تنافسية عالمياً
هدفنا في هذا الموقع هو تحسين وتيسير بيئة الأعمال بالمملكة وتطويرها عن طريق التكاتفت بين الحكومات والشركات وزيادة فرص التعاون بينهم"`,
        },
        {
          id: "2",
          img: "news2.jpeg",
          title:
            "صاحب السمو الملكي ",
          description: `الأمير محمد بن سلمان بن عبدالعزيز آل سعود
                ولي العهد، رئيس مجلس الوزراء ورئيس مجلس الشؤون الاقتصادية والتنمية

"مستقبل المملكة وازدهارها، يقوم على العلاقة التشاركية بين القطاعين الحكومي والخاص، لذا يعد بناء قطاع خاص حيوي ومزدهر من الأولويات الوطنية."
"`,
        },
      ],
    };
  },
  setup() {
    return {
      modules: [Navigation, EffectFade, Autoplay],
    };
  },
};
</script>
<style lang="scss" scoped>
.news-des{
  font-size: 18px;
}
</style>